import '../filter_view.js.coffee';# Added by Script 
Monitoring.Views.SocialContents ||= {}
Monitoring.Views.SocialContents.Filters ||= {}

class Monitoring.Views.SocialContents.Filters.SubtypeFilterView extends Monitoring.Views.SocialContents.Filters.FilterView
  name: 'sub_type'
  alias: 'Source Type'
  facetName: 'sub_type'
  humanize: true
  selectAll: true
  visibleInMyHistorySession: false

  getAppliedValues: ->
    return @searchQuery.get('sub_type')

  addFilter: (value) ->
    @searchQuery.addSubtype(value)

  getDescription: (facet) ->
    return @getTranslator().getTranslation(facet.term)

  getTranslator: ->
    @translator = new Monitoring.Views.SocialContents.Filters.SubTypeTranslations() unless @translator?
    return @translator

